/* eslint-disable */

import ExploreFeed from "components/features/explore-feed/ExploreFeed";

const ExploreFeedPage = () => {
  return <ExploreFeed />;
};

export default ExploreFeedPage;
